/* The rate pages (round 41): sections/vr-rates.liquid, with assets/vr-rates.css.

   Every figure is printed by the page. This script:
   - writes the date of the day (India time) and keeps it right past midnight;
   - lights the niches one by one as the board appears, each mark taking one band of light, and now and then lets a
     band of light cross one figure in turn, so a board left open stays quietly alive;
   - asks for its own section every few minutes (data-refresh) and, when the rate has been changed in the admin,
     turns the changed figures over in place; a page open for more than half a day reloads itself once;
   - runs the calculator, opens the questions smoothly and hides the pointer when it rests on the board;
   - lets gold or silver leaf drift over the board and settle at its foot (the leaf of round 23: no glint, each piece
     slowing over its last stretch and lying where it fell, in an uneven drift). It stops when the board is out of
     view or the tab is hidden.
   Visitors who ask for reduced motion see the board still (a quiet scatter of leaf, no beats, no turning). */
(function () {
  'use strict';
  if (window.__vrRates) return;
  window.__vrRates = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var conn = navigator.connection || {};
  var saving = conn.saveData || /(^|-)2g$/.test(conn.effectiveType || '');
  var OPENED = Date.now();

  function money(n) { return '₹' + Math.round(n).toLocaleString('en-IN'); }
  function trim(n) { return String(parseFloat(Number(n).toFixed(3))); }
  function each(list, fn) { Array.prototype.forEach.call(list, fn); }
  function readData(scope) {
    var el = scope.querySelector('[data-vrr-data]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  function today() {
    try {
      var parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Asia/Kolkata', weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' }).formatToParts(new Date());
      var get = function (t) { for (var i = 0; i < parts.length; i++) if (parts[i].type === t) return parts[i].value; return ''; };
      return get('weekday') + ', ' + get('day') + ' ' + get('month') + ' ' + get('year');
    } catch (e) { return null; }
  }

  function rates(root) {
    var data = readData(root);
    if (!data) return;
    var metal = data.metal === 'silver' ? 'silver' : 'gold';
    var board = root.querySelector('[data-vrr-board]');
    var niches = root.querySelectorAll('.vrr-niche');
    var dateEl = root.querySelector('[data-vrr-date]');
    var calcWeight = root.querySelector('[data-vrr-weight]');
    var calcPurity = root.querySelector('[data-vrr-purity]');
    var calcValue = root.querySelector('[data-vrr-value]');
    var calcNote = root.querySelector('[data-vrr-note]');
    var current = data.rates || {};
    var label = function (key) { return metal === 'silver' ? String(key) : String(key).toUpperCase(); };

    /* ---- the date ---- */
    function writeDate() { var t = today(); if (t && dateEl && dateEl.textContent !== t) dateEl.textContent = t; }
    writeDate();
    window.setInterval(writeDate, 60000);

    /* ---- the calculator ---- */
    function calculate() {
      if (!calcWeight || !calcPurity) return;
      var weight = parseFloat(calcWeight.value);
      var rate = current[calcPurity.value];
      if (!(weight > 0) || !rate) {
        calcValue.textContent = money(0);
        calcNote.textContent = rate ? 'Enter a weight to see its value.' : 'The rate of the day has not been set yet.';
        return;
      }
      calcValue.textContent = money(rate * weight);
      calcNote.textContent = trim(weight) + ' g × ' + money(rate) + ' a gram, ' + label(calcPurity.value) + ' ' + metal + '.';
    }
    if (calcWeight && calcPurity) {
      [calcWeight, calcPurity].forEach(function (field) { field.addEventListener('input', calculate); field.addEventListener('change', calculate); });
      calculate();
    }

    /* ---- the beats ---- */
    if (!reduce && board) {
      root.classList.add('is-armed');
      window.requestAnimationFrame(function () { window.requestAnimationFrame(function () { each(niches, function (n) { n.classList.add('is-lit'); }); }); });
      var turn = 0;
      window.setInterval(function () {
        if (document.hidden || !niches.length) return;
        var span = niches[turn % niches.length].querySelector('[data-vrr-figure]');
        turn++;
        if (!span || span.classList.contains('is-turning')) return;
        span.classList.remove('is-gleam');
        void span.offsetWidth;
        span.classList.add('is-gleam');
      }, 36000);
      root.addEventListener('animationend', function (e) { if (e.target.classList && e.target.classList.contains('is-gleam')) e.target.classList.remove('is-gleam'); });
    } else {
      each(niches, function (n) { n.classList.add('is-lit'); });
    }

    /* ---- a new rate: the changed figures turn over in place ---- */
    /* the small line: the amount (in the figures' face) and its unit, made when the board had no rate */
    function writeMore(moreEl, amount) {
      if (!moreEl) return;
      var amt = moreEl.querySelector('[data-vrr-amt]');
      if (!amt) {
        moreEl.textContent = '';
        amt = document.createElement('span');
        amt.className = 'vrr-amt';
        amt.setAttribute('data-vrr-amt', '');
        moreEl.appendChild(amt);
        moreEl.appendChild(document.createTextNode(' ' + (moreEl.getAttribute('data-unit') || '')));
      }
      amt.textContent = amount;
      moreEl.hidden = false;
    }
    function setFigure(span, text, moreEl, moreText) {
      var amt = moreEl && moreEl.querySelector('[data-vrr-amt]');
      if (span.textContent.trim() === text) { if (moreEl && (!amt || amt.textContent.trim() !== moreText)) writeMore(moreEl, moreText); return; }
      if (reduce) { span.textContent = text; writeMore(moreEl, moreText); return; }
      span.classList.remove('is-gleam');
      span.classList.add('is-turning');
      if (moreEl) moreEl.classList.add('is-turning');
      window.setTimeout(function () {
        span.textContent = text;
        span.classList.remove('is-turning');
        span.classList.add('is-arriving');
        writeMore(moreEl, moreText);
        void span.offsetWidth;
        span.classList.remove('is-arriving');
        if (moreEl) moreEl.classList.remove('is-turning');
        window.setTimeout(function () { span.classList.add('is-gleam'); }, 900);
      }, 650);
    }
    function apply(next) {
      var nextRates = (next && next.rates) || {};
      var had = Object.keys(current).length > 0, has = Object.keys(nextRates).length > 0;
      if (had && !has) { window.location.reload(); return; }
      if (!has) return;
      each(niches, function (n) {
        var key = n.getAttribute('data-purity');
        var rate = nextRates[key];
        if (!rate) return;
        setFigure(n.querySelector('[data-vrr-figure]'), money(rate * data.boardWeight), n.querySelector('[data-vrr-more]'), money(rate * data.moreWeight));
      });
      current = nextRates;
      if (!had) {
        root.classList.remove('is-unset');
        var unset = root.querySelector('.vrr-board__unset');
        if (unset) unset.remove();
      }
      calculate();
    }

    /* ---- looking for a new rate every few minutes, while the page is shown ---- */
    var sid = root.getAttribute('data-sid');
    var every = Math.max(2, parseFloat(root.getAttribute('data-refresh')) || 5) * 60000;
    var lastCheck = Date.now(), checking = false;
    function check() {
      if (checking || document.hidden || !sid || !window.fetch || !window.DOMParser) return;
      if (Date.now() - OPENED > 12 * 3600000) { window.location.reload(); return; }
      checking = true;
      lastCheck = Date.now();
      var url = window.location.pathname + '?section_id=' + encodeURIComponent(sid) + '&vrr=' + Date.now();
      window.fetch(url, { credentials: 'same-origin', cache: 'no-store' })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          var doc = new window.DOMParser().parseFromString(html, 'text/html');
          var next = readData(doc);
          if (next) apply(next);
        })
        .catch(function () {})
        .then(function () { checking = false; });
    }
    window.setInterval(check, every);
    document.addEventListener('visibilitychange', function () { if (!document.hidden && Date.now() - lastCheck > every) check(); });

    /* ---- the pointer rests: hide it over the board (a mouse left on a screen) ---- */
    if (board && window.matchMedia && window.matchMedia('(pointer: fine)').matches) {
      var idle = 0;
      var wake = function () { board.classList.remove('is-idle'); window.clearTimeout(idle); idle = window.setTimeout(function () { board.classList.add('is-idle'); }, 4000); };
      board.addEventListener('mousemove', wake, { passive: true });
      board.addEventListener('mouseleave', function () { window.clearTimeout(idle); board.classList.remove('is-idle'); });
    }

    /* ---- the questions open and close smoothly ---- */
    each(root.querySelectorAll('.vrr-q'), function (q) {
      var head = q.querySelector('summary');
      var body = q.querySelector('.vrr-q__body');
      if (!head || !body || reduce || !body.animate) return;
      var ease = 'cubic-bezier(0.22, 0.61, 0.36, 1)';
      head.addEventListener('click', function (e) {
        e.preventDefault();
        if (q.open) {
          var h = body.offsetHeight;
          var a = body.animate([{ height: h + 'px' }, { height: '0px' }], { duration: 450, easing: ease });
          a.onfinish = function () { q.open = false; };
        } else {
          q.open = true;
          var h2 = body.offsetHeight;
          body.animate([{ height: '0px' }, { height: h2 + 'px' }], { duration: 450, easing: ease });
        }
      });
    });

    /* ---- the scenes below rise into place as they come into view ---- */
    if ('IntersectionObserver' in window && !reduce) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
      }, { rootMargin: '0px 0px -8% 0px' });
      each(root.querySelectorAll('[data-vrr-reveal]'), function (el) {
        if (el.getBoundingClientRect().top < window.innerHeight * 0.92) return;
        el.classList.add('is-armed');
        io.observe(el);
      });
    }

    leaf(root, metal);
  }

  /* ---------------------------------------------------------------- the leaf (round 23) */
  var PALETTES = {
    /* lit face, body, deep edge */
    gold: [
      [[255, 246, 205], [240, 203, 105], [138, 94, 10]],
      [[255, 238, 178], [226, 182, 74], [122, 82, 12]],
      [[255, 250, 228], [244, 214, 128], [160, 112, 22]]
    ],
    silver: [
      [[255, 255, 255], [214, 221, 228], [112, 122, 134]],
      [[250, 252, 255], [196, 204, 213], [98, 108, 120]],
      [[255, 255, 255], [228, 233, 238], [132, 142, 153]]
    ]
  };

  function leaf(root, metal) {
    var canvas = root.querySelector('[data-vrr-leaf]');
    var board = root.querySelector('[data-vrr-board]');
    if (!canvas || !board || !canvas.getContext || root.getAttribute('data-flakes') === 'off') { if (canvas) canvas.remove(); return; }
    var palettes = PALETTES[metal] || PALETTES.gold;
    var still = reduce || saving;
    var ctx = canvas.getContext('2d');
    var w = 0, h = 0, dpr = 1;
    var pieces = [], running = false, visible = false, last = 0, clock = 0, raf = 0;
    var pile = [], pileMax = 0, rested = [], restMax = 0, pileCanvas = document.createElement('canvas'), pileCtx = pileCanvas.getContext('2d');
    var PILE_COL = 6, SETTLE = 80; /* the ground is measured in columns this wide; a piece slows over this many pixels */

    function rand(a, b) { return a + Math.random() * (b - a); }
    function shape() {
      /* an irregular pentagon or hexagon: angles spread round the circle, radii jittered */
      var n = 5 + Math.floor(Math.random() * 2), points = [], a = rand(0, Math.PI * 2);
      for (var i = 0; i < n; i++) {
        a += (Math.PI * 2 / n) * rand(0.6, 1.4);
        var r = rand(0.55, 1);
        points.push([Math.cos(a) * r, Math.sin(a) * r * rand(0.7, 1)]);
      }
      return points;
    }
    function piece(fresh) {
      var depth = Math.random(); /* 0 far: small, slow, faint. 1 near: larger, quicker, bright */
      return {
        x: rand(0, w), y: fresh ? rand(-60, -8) : rand(0, h),
        size: 2.6 + depth * 5.4, speed: 14 + depth * 26,
        sway: rand(6, 22), swayK: 1, swaySpeed: rand(0.3, 0.8), phase: rand(0, Math.PI * 2),
        rot: rand(0, Math.PI * 2), rotSpeed: rand(-0.9, 0.9), flip: rand(0, Math.PI * 2), flipSpeed: rand(0.6, 1.7),
        alpha: 0.5 + depth * 0.45, depth: depth,
        tones: palettes[Math.floor(Math.random() * palettes.length)], points: shape()
      };
    }
    function fit(c, g, width, height) { c.width = Math.max(1, Math.round(width * dpr)); c.height = Math.max(1, Math.round(height * dpr)); g.setTransform(dpr, 0, 0, dpr, 0, 0); }
    function measure() {
      var oldH = h, oldCols = pile.length;
      dpr = Math.min(2, window.devicePixelRatio || 1);
      w = canvas.clientWidth; h = canvas.clientHeight;
      fit(canvas, ctx, w, h);
      var count = Math.max(18, Math.min(64, Math.round(w * h / 34000))); /* lighter than the old desk: a board is for reading */
      while (pieces.length < count) pieces.push(piece(false));
      pieces.length = count;
      /* the ground and the drift: kept through a change of height alone, begun afresh at a new width */
      fit(pileCanvas, pileCtx, w, h);
      var cols = Math.ceil(w / PILE_COL), k;
      if (cols !== oldCols) { pile = []; for (k = 0; k < cols; k++) pile.push(0); rested = []; }
      else if (oldH && h !== oldH) { for (k = 0; k < rested.length; k++) rested[k].y += h - oldH; }
      pileMax = Math.round(h * 0.045);
      restMax = Math.max(40, Math.round(w / 8));
      for (k = 0; k < rested.length; k++) lay(rested[k]);
    }
    function mix(a, b, t) { return 'rgb(' + Math.round(a[0] + (b[0] - a[0]) * t) + ',' + Math.round(a[1] + (b[1] - a[1]) * t) + ',' + Math.round(a[2] + (b[2] - a[2]) * t) + ')'; }
    /* no glint: leaf does not sparkle; a piece is only a little paler as its face turns to the light */
    function facet(g, p, x, y, lit) {
      g.save();
      g.translate(x, y);
      g.rotate(p.rot);
      g.scale(p.size, p.size * Math.max(0.1, lit));
      g.beginPath();
      for (var i = 0; i < p.points.length; i++) { if (i === 0) g.moveTo(p.points[i][0], p.points[i][1]); else g.lineTo(p.points[i][0], p.points[i][1]); }
      g.closePath();
      g.globalAlpha = p.alpha;
      g.fillStyle = lit > 0.5 ? mix(p.tones[1], p.tones[0], (lit - 0.5) * 1.3) : mix(p.tones[2], p.tones[1], lit * 2);
      g.fill();
      g.globalAlpha = p.alpha * 0.55;
      g.lineWidth = 0.9 / p.size;
      g.strokeStyle = 'rgb(' + p.tones[2][0] + ',' + p.tones[2][1] + ',' + p.tones[2][2] + ')';
      g.stroke();
      g.restore();
    }
    function draw(g, p, x, y) { facet(g, p, x, y, Math.abs(Math.cos(p.flip))); }
    /* the leaf comes to rest: the foot of the board is the ground; the drift rises unevenly where pieces have fallen */
    function ground(x) { var c = Math.max(0, Math.min(pile.length - 1, Math.floor(x / PILE_COL))); return h - (pile[c] || 0); }
    function lay(r) { facet(pileCtx, r, r.x, r.y, r.lit); }
    function settle(p, x) {
      var c = Math.max(0, Math.min(pile.length - 1, Math.floor(x / PILE_COL))), add = p.size * 0.3;
      pile[c] = Math.min(pileMax, (pile[c] || 0) + add);
      if (c > 0) pile[c - 1] = Math.min(pileMax, (pile[c - 1] || 0) + add * 0.45);
      if (c + 1 < pile.length) pile[c + 1] = Math.min(pileMax, (pile[c + 1] || 0) + add * 0.45);
      var r = { x: x, y: p.y, rot: p.rot, lit: rand(0.3, 0.85), size: p.size, alpha: p.alpha, tones: p.tones, points: p.points };
      rested.push(r);
      if (rested.length > restMax) {
        /* the drift is full: the oldest quarter goes and the rest is drawn again */
        rested.splice(0, Math.ceil(restMax * 0.25));
        pileCtx.clearRect(0, 0, w, h);
        for (var i = 0; i < rested.length; i++) lay(rested[i]);
      } else lay(r);
    }
    function frame(now) {
      raf = 0;
      if (!running) return;
      var dt = Math.min(0.05, (now - last) / 1000 || 0);
      last = now;
      clock += dt;
      if (Math.abs(canvas.clientWidth - w) > 1 || Math.abs(canvas.clientHeight - h) > 1) measure();
      ctx.clearRect(0, 0, w, h);
      ctx.drawImage(pileCanvas, 0, 0, w, h);
      for (var i = 0; i < pieces.length; i++) {
        var p = pieces[i];
        var x = p.x + Math.sin(p.phase + clock * p.swaySpeed) * p.sway * p.swayK;
        var left = ground(x) - p.size * 0.45 - p.y;
        if (left < SETTLE) {
          /* the last stretch: slower as the ground nears, the sway dying, the turning too */
          p.y += p.speed * Math.max(0.1, left / SETTLE) * dt;
          p.swayK = Math.max(0, p.swayK - dt * 1.2);
          p.flipSpeed *= 1 - 1.4 * dt;
          p.rotSpeed *= 1 - 1.4 * dt;
          if (left <= 0.5) { settle(p, x); pieces[i] = piece(true); continue; }
        } else {
          p.y += p.speed * dt;
        }
        p.rot += p.rotSpeed * dt;
        p.flip += p.flipSpeed * dt;
        draw(ctx, p, x, p.y);
      }
      raf = window.requestAnimationFrame(frame);
    }
    function start() { if (running || still || !visible || document.hidden) return; running = true; last = performance.now(); raf = window.requestAnimationFrame(frame); }
    function stop() { running = false; if (raf) window.cancelAnimationFrame(raf); raf = 0; }

    measure();
    if (still) {
      /* a quiet scatter over the board */
      var n = Math.max(14, Math.round(w * h / 32000));
      for (var i = 0; i < n; i++) { var p = piece(false); p.flip = rand(-0.5, 0.5); draw(ctx, p, rand(0, w), rand(0, h)); }
      return;
    }
    var rt = 0;
    window.addEventListener('resize', function () { window.clearTimeout(rt); rt = window.setTimeout(measure, 160); });
    document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else start(); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) { visible = entries[0].isIntersecting; if (visible) start(); else stop(); }).observe(board);
    } else { visible = true; start(); }
  }

  function boot() {
    each(document.querySelectorAll('[data-vrr]'), function (root) {
      if (root.getAttribute('data-vrr-ready')) return;
      root.setAttribute('data-vrr-ready', '1');
      rates(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function () { window.__vrRates = true; boot(); });
})();
